import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { agentSetupService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";
import { EnumValue } from "types/enums/customEnum";

const useSetAgentResidualsStatusMutation = ({
	withoutLoading = false,
}: {
	withoutLoading?: boolean;
} = {}) => {
	const dispatch = useDispatch();

	return useMutation(
		({
			residualsStatus,
			withholdReason,
			agentId,
		}: {
			residualsStatus: number | string | null;
			withholdReason?: number | EnumValue;
			agentId: string;
			onSuccess?: Function;
		}) =>
			agentSetupService.setResidualsStatus(agentId, {
				residualsStatus,
				withholdReason,
			}),
		{
			onMutate() {
				!withoutLoading && dispatch(uiActions.showSpinnerOverlay());
			},
			onSuccess(_data, { onSuccess }) {
				onSuccess?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
		},
	);
};

export default useSetAgentResidualsStatusMutation;
